export default __webpack_public_path__ + "static/media/AM.898c4a08.jpg";